$(document).ready(function(){
  function CheckPassengerField(){
    var Flag=0;
      var DOBName,dateName,PassNoName,DOB,addDetails,addDetailsVal,date,PassNo,_this,validated=false,hearAboutUs,hearAboutUsOther,cart_attributes='',FirstName,LastName,Loction,FirstNameVal,LastNameVal,LoctionVal,Flag=0,FullName,FullNameVal,Email,Phone,Age,Sex,Ehnicity,Nationality,RecivedVaccine,vacineknown,DateArrival,TimeArrival,TravelNo,CountryDept,TravelCountry,NhsNo,TransitedCountry,SelfIso,AddrsLine1,AddrsLine2,Town,PostalCode,EmailName,PhoneName,AgeName,SexName,EhnicityName,NationalityName,RecivedVaccineName,vacineName,DateArrivalName,TimeArrivalName,TravelNoName,CountryDeptName,TravelCountryName,NhsNoName,TransitedCountryName,SelfIsoName,AddrsLine1Name,AddrsLine2Name,TownName,PostalCodeName,lastDeptDate,lastDeptDateName;    
  
    $('.passenger_detail_inner .details').each(function(){
      var FirstNameVal= $.trim($('.fName',this).val());
      var  LastNameVal= $.trim($('.lName',this).val());
      var DOB= $.trim($('.DOB',this).val());
      var addDetails= $.trim($('.addDetails',this).val());
      var  date= $.trim($('.date',this).val());
      var  PassNo= $.trim($('.PassNo',this).val());
      if($('.DOB',this).length >0){
        if(FirstNameVal=='' || LastNameVal=='' || DOB =='' || date=='' || PassNo==''){
          Flag=1;
        }
      }else if($('.addDetails',this).length >0){
        if(FirstNameVal=='' || LastNameVal=='' || addDetails ==''){
          Flag=1;
        }
      }
      else{
        if(FirstNameVal=='' || LastNameVal==''){
          Flag=1;
        }
      }
      
      if($('.email',this).length >=0){
           Email = $('.email',this).attr('name'); 
        if(EmailName==''){
          Flag=1;
          $('.email',this).css('border', 'solid 2px red');
        }
      }

          
      if($('.phone',this).length >=0){
         Phone = $('.phone',this).attr('name'); 
       if(PhoneName==''){
          Flag=1;
          $('.phone',this).css('border', 'solid 2px red');
        }
      }
      
      
      if($('.age',this).length >=0){
        Age = $('.age',this).attr('name'); 
     	if(AgeName==''){
          Flag=1;
          $('.age',this).css('border', 'solid 2px red');
        }
      }
      
     
    });
    if(Flag==1){
      //$('.cart__submit[name="checkout"]').attr('disabled',true);
      $('.cart__error-message-wrapper').removeClass('hide');
      $('.cart__error-message').html("Fill all the passenger Details");
    }
    else{
      //$('.cart__submit[name="checkout"]').attr('disabled',false);
      $('.cart__error-message-wrapper').addClass('hide');
      $('.cart__error-message').html("");
    }
  }
   function locatorNumber() {
    //get location number private app
    var locatorNumber = '',
        locatorNumberApi, flag2 = 0;
     $.ajax({
        type: 'GET',
        url: 'https://check2go.co.uk/cart',
        async: false,
        dataType: 'html',
       success: function(response) {
        console.log($('.StoreLocatorNumber',response).html());
          locatorNumber=$('.StoreLocatorNumber',response).html();
           $.ajax({
        type: 'GET',
        url: 'https://jeronone.com/test-server/afzal/locator.php',
        async: false,
        dataType: 'json',
        success: function(note_attributes) {
            console.log(note_attributes);
            if (note_attributes.length > 0) {
                var location = [];
                $.each(note_attributes, function(index, value) {
                    if (note_attributes[index].name.indexOf('Passenger Locator Number') > -1) {
                        location.push(note_attributes[index].value);
                    }
                });
                console.log(location);
                if (location.length > 0) {
                    locatorNumber = location[location.length - 1];
                }
                console.log(locatorNumber);
                flag2 = 1;
            }
                $('.passenger_detail_inner .details .Locator_number').each(function(index) { // Insert the locator number in the locator hidden field
                    var LocationVal1 = locatorNumber.split('E000')[0];
                    var LocationVal2 = parseInt(locatorNumber.split('E000')[1]);
                    LocationVal2 = LocationVal2 + 1;

                    locatorNumber = LocationVal1 + 'E000' + LocationVal2;
                    $(this).val(locatorNumber);
                });
               
               
           

        },
        error: function(error) {
            console.log(error);
            $.ajax({
                type: 'POST',
                data: {'error_msg': error},
                url:'https://jeronone.com/test-server/afzal/boski/mail.php',
                async: false,
                dataType: 'json',
                success: function(response) {
                    console.log(response);
                }
            });
        }
    });
       }
     });
   
    
}
   $("body").on('keyup keypress','.passenger_detail_inner .details input',function(){
    $(this).css('border', '1px solid #53babc');
     CheckPassengerField();
  });
  
     CheckPassengerField();
    
 
  $('#save_details ,input[name="checkout"]').click(function(e){
    e.preventDefault();
   // var DOBName,dateName,PassNoName,DOB,addDetails,addDetailsVal,date,PassNo,_this,validated=false,hearAboutUs,hearAboutUsOther,cart_attributes='',FirstName,LastName,Loction,FirstNameVal,LastNameVal,LoctionVal,Flag=0,FullName,FullNameVal;
    var DOBName,dateName,PassNoName,DOB,addDetails,addDetailsVal,date,PassNo,_this,validated=false,hearAboutUs,hearAboutUsOther,cart_attributes='',FirstName,LastName,Loction,FirstNameVal,LastNameVal,LoctionVal,Flag=0,FullName,FullNameVal,Email,Phone,Age,Sex,Ehnicity,Nationality,RecivedVaccine,vacineknown,DateArrival,TimeArrival,TravelNo,CountryDept,TravelCountry,NhsNo,TransitedCountry,SelfIso,AddrsLine1,AddrsLine2,Town,PostalCode,EmailName,PhoneName,AgeName,SexName,EhnicityName,NationalityName,RecivedVaccineName,vacineName,DateArrivalName,TimeArrivalName,TravelNoName,CountryDeptName,TravelCountryName,NhsNoName,TransitedCountryName,SelfIsoName,AddrsLine1Name,AddrsLine2Name,TownName,PostalCodeName,lastDeptDate,lastDeptDateName,kitGov,kitGov_val,kitaddName,kitadd_Value;    
     var homeAddress1Name,homeAddress1value,homeAddress2Name,homeAddress2Value,homeTownName,homeTownValue,homePostalName,homePostalValue;
    $(this).attr('disabled','disabled');
    _this=$(this);
    
    hearAboutUs=$('#how-did-you-hear-about-us option:selected').val();
    hearAboutUsOther= $('#how-did-you-hear-about-us-other').val();
    $('.passenger_detail_inner .details').each(function(){
      FirstName= $('.fName',this).attr('name');
      LastName= $('.lName',this).attr('name');
      FullName= $('.FullName',this).attr('name');
      addDetails= $('.addDetails',this).attr('name');
      Loction= $('.Locator_number',this).attr('name');
      FirstNameVal= $.trim($('.fName',this).val());
      LastNameVal= $.trim($('.lName',this).val());
      LoctionVal= $('.Locator_number',this).val();
      DOB= $.trim($('.DOB',this).val());
      addDetailsVal= $.trim($('.addDetails',this).val());
      date= $.trim($('.date',this).val());
      PassNo= $.trim($('.PassNo',this).val());
      DOBName= $('.DOB',this).attr('name');
      dateName= $('.date',this).attr('name');
      PassNoName= $('.PassNo',this).attr('name');
      if(DOB =='' && DOB!=undefined && $('.DOB',this).length >0){
        $('.DOB',this).css('border', 'solid 2px red');
        Flag=1;
      }
       if(addDetailsVal =='' && addDetailsVal!=undefined && $('.addDetails',this).length >0){
        $('.addDetails',this).css('border', 'solid 2px red');
        Flag=1;
      }
      if(date=='' && date!=undefined && $('.date',this).length >0){
        $('.date',this).css('border', 'solid 2px red');
        Flag=1;
      }
      if(PassNo=='' && PassNo!=undefined &&  $('.PassNo',this).length >0){
        $('.PassNo',this).css('border', 'solid 2px red');
        Flag=1;
      }
     
      if(FirstNameVal==''){
        $('.fName',this).css('border', 'solid 2px red');
        Flag=1;
      }
      if(LastNameVal==''){
        Flag=1;
        $('.lName',this).css('border', 'solid 2px red');
      }
      FullNameVal = FirstNameVal+' '+LastNameVal;
      $('.FullName',this).val(FullNameVal);
		
      if(cart_attributes==''){
        cart_attributes=FullName+'='+FullNameVal;
      }else{
        cart_attributes+='&'+FullName+'='+FullNameVal;
      }
       if(LoctionVal!='' && LoctionVal!=undefined){    
      	cart_attributes+='&'+Loction+'='+LoctionVal;
       }
    
      if(DOB!='' && DOB!=undefined){
        cart_attributes+='&'+DOBName+'='+DOB;
        
      }
      if(date!='' && date!=undefined){
        cart_attributes+='&'+dateName+'='+date;
      }
     
      if(addDetailsVal!='' && addDetailsVal!=undefined){
        cart_attributes+='&'+addDetails+'='+addDetailsVal;
      }
      
      
      if(PassNo!='' && PassNo!=undefined){
         cart_attributes+='&'+PassNoName+'='+PassNo;
      }
      
       Email = $('.email',this).attr('name'); 
      if($('.email',this).length >=0){
        EmailName = $.trim($('.email',this).val());
        cart_attributes+='&'+Email+'='+EmailName;
      }

      
//       if(EmailName==''){
//        Flag=1;
//          console.log(7);
//        $('.email',this).css('border', 'solid 2px red');
//       }
      
      Phone = $('.phone',this).attr('name'); 
      if($('.phone',this).length >=0){
        PhoneName = $.trim($('.phone',this).val());
        cart_attributes+='&'+Phone+'='+PhoneName;
      }
      
//      if(PhoneName==''){
//        Flag=1;
//         console.log(8);
//         $('.phone',this).css('border', 'solid 2px red');
//      }
      
      Age = $('.age',this).attr('name'); 
      if($('.age',this).length >=0){
        AgeName = $.trim($('.age',this).val());
        cart_attributes+='&'+Age+'='+AgeName;
      }
      
     // if(AgeName==''){
     //   Flag=1;
      //   console.log(9);
       // $('.age',this).css('border', 'solid 2px red');
     // }
      
      Sex= $('.sexval',this).attr('name'); 
      if($('.sexval',this).length >=0){
        SexName=$.trim($('.sexval',this).val()); //$("input[type='radio'].sexval:checked").val();
        cart_attributes+='&'+Sex+'='+SexName;
      }
      
      
      Ehnicity=$('.ethicity',this).attr('name');
      if($('.ethicity',this).length >=0){
        EhnicityName=$.trim($('.ethicity',this).val());
        cart_attributes+='&'+Ehnicity+'='+EhnicityName;
      }
      
//        if(EhnicityName==''){
//        Flag=1;
//         console.log(9);
//        $('.ethicity',this).css('border', 'solid 2px red');
//      }
      
      Nationality=$('.nation',this).attr('name');
      if($('.nation',this).length >=0){
        NationalityName=$.trim($('.nation',this).val());
        cart_attributes+='&'+Nationality+'='+NationalityName;
      }
      
      RecivedVaccine=$('.recive_vacci',this).attr('name');
      if($('.recive_vacci',this).length >=0){
        RecivedVaccineName=$("input[type='radio'].recive_vacci:checked").val();
        cart_attributes+='&'+RecivedVaccine+'='+RecivedVaccineName;
      }
      
      vacineknown=$('.vacciName',this).attr('name');
      if($('.vacciName',this).length >=0){
        vacineName=$.trim($('.vacciName',this).val());
        cart_attributes+='&'+vacineknown+'='+vacineName;
      }
      
      DateArrival=$('.date_arrival',this).attr('name');
      if($('.date_arrival',this).length >=0){
        DateArrivalName=$.trim($('.date_arrival',this).val());
        cart_attributes+='&'+DateArrival+'='+DateArrivalName;
      }
      
      TimeArrival=$('.time_arrivals',this).attr('name');
      if($('.time_arrivals',this).length >=0){
        TimeArrivalName=$.trim($('.time_arrivals',this).val());
        cart_attributes+='&'+TimeArrival+'='+TimeArrivalName;
      }
      TravelNo=$('.travel_no',this).attr('name');
      if($('.travel_no',this).length >=0){
        TravelNoName=$.trim($('.travel_no',this).val());
        cart_attributes+='&'+TravelNo+'='+TravelNoName;
      }

      CountryDept=$('.dep_country',this).attr('name');
      if($('.dep_country',this).length >=0){
        CountryDeptName=$.trim($('.dep_country',this).val());
        cart_attributes+='&'+CountryDept+'='+CountryDeptName;
      }
      
      TravelCountry=$('.cntry_level',this).attr('name');
      if($('.cntry_level',this).length >=0){
        TravelCountryName=$.trim($('.cntry_level',this).val());
        cart_attributes+='&'+TravelCountry+'='+TravelCountryName;
      }
      
      NhsNo=$('.NhsNo',this).attr('name');
      if($('.NhsNo',this).length >=0){
        NhsNoName=$.trim($('.NhsNo',this).val());
        cart_attributes+='&'+NhsNo+'='+NhsNoName;
      }
      
      TransitedCountry=$('.ttCountry',this).attr('name');
      if($('.ttCountry',this).length >=0){
        TransitedCountryName=$.trim($('.ttCountry',this).val());
        cart_attributes+='&'+TransitedCountry+'='+TransitedCountryName;
      }

//       SelfIso=$('.isolate',this).attr('name');
//       if($('.isolate',this).length >=0){
//         SelfIsoName=$("input[type='radio'].isolate:checked").val();
//         cart_attributes+='&'+SelfIso+'='+SelfIsoName;
//       }
      
      AddrsLine1=$('.addressl1',this).attr('name');
      if($('.addressl1',this).length >=0){
        AddrsLine1Name=$.trim($('.addressl1',this).val());
        cart_attributes+='&'+AddrsLine1+'='+AddrsLine1Name;
      }

      AddrsLine2=$('.addressl2',this).attr('name');
      if($('.addressl2',this).length >=0){
        AddrsLine2Name=$.trim($('.addressl2',this).val());
        cart_attributes+='&'+AddrsLine2+'='+AddrsLine2Name;
      }
      
      Town=$('.addressTown',this).attr('name');
      if($('.addressTown',this).length >=0){
        TownName=$.trim($('.addressTown',this).val());
        cart_attributes+='&'+Town+'='+TownName;
      }

      PostalCode=$('.addressPostalCode',this).attr('name');
      if($('.addressPostalCode',this).length >=0){
        PostalCodeName=$.trim($('.addressPostalCode',this).val());
        cart_attributes+='&'+PostalCode+'='+PostalCodeName;
      }
      
      /*home address*/
      
      homeAddress1Name=$('.homeaddressl1',this).attr('name');
      if($('.homeaddressl1',this).length >=0){
        homeAddress1value=$.trim($('.homeaddressl1',this).val());
        cart_attributes+='&'+homeAddress1Name+'='+homeAddress1value;
      }

      homeAddress2Name=$('.homeaddressl2',this).attr('name');
      if($('.homeaddressl2',this).length >=0){
        homeAddress2Value=$.trim($('.homeaddressl2',this).val());
        cart_attributes+='&'+homeAddress2Name+'='+homeAddress2Value;
      }
      
      homeTownName=$('.homeaddressTown',this).attr('name');
      if($('.homeaddressTown',this).length >=0){
        homeTownValue=$.trim($('.homeaddressTown',this).val());
        cart_attributes+='&'+homeTownName+'='+homeTownValue;
      }

      homePostalName=$('.homeaddressPostalCode',this).attr('name');
      if($('.homeaddressPostalCode',this).length >=0){
        homePostalValue=$.trim($('.homeaddressPostalCode',this).val());
        cart_attributes+='&'+homePostalName+'='+homePostalValue;
      }
      /*close home address*/
      lastDeptDate=$('.ldp',this).attr('name');
      if($('.ldp',this).length >=0){
        lastDeptDateName=$.trim($('.ldp',this).val());
        cart_attributes+='&'+lastDeptDate+'='+lastDeptDateName;
      }
      
      kitGov=$('.kit_gov',this).attr('name');
      if($('.kit_gov',this).length >=0){
        kitGov_val=$.trim($('.kit_gov:checked',this).val());
        cart_attributes+='&'+kitGov+'='+kitGov_val;
      }
      
      kitaddName= $('.kitadd',this).attr('name');
      
      if($('.kitadd',this).length >=0){
        kitadd_Value=$.trim($('.kitadd',this).val());
        cart_attributes+='&'+kitaddName+'='+kitadd_Value;
      }
      
     }); 
     if($('.yes_btn').length >0){
        $('.yes_btn').parent("p").css('border', 'solid 2px red');
        Flag=1;
      }
    
    if(hearAboutUs !=''){
     // cart_attributes+='&attributes[how-did-you-hear-about-us]='+hearAboutUs;
    }
    if(hearAboutUs == 'Other' && $.trim($('#how-did-you-hear-about-us-other').val()) !='' && $.trim($('#how-did-you-hear-about-us-other').val()) !=undefined ){
     // cart_attributes+='&attributes[how-did-you-hear-about-us-other]='+hearAboutUsOther;
    }
    console.log("Flag="+Flag);
    if(Flag==0){
      //console.log(cart_attributes);
      locatorNumber(); // Call locator function to get last order number
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        dataType: 'json',
        async:false,
        data:cart_attributes,
        success: function(data) {
          console.log(data);
          $('.success_message2').html("Passenger's data added successfully").fadeIn();
          $('.success_message2').delay(4000).fadeOut();
          _this.attr('disabled',false);
          if(hearAboutUs !=''){
            validated=true;
          }
          if(hearAboutUs == 'Other' && $.trim($('#how-did-you-hear-about-us-other').val()) !=''){
            validated=true;
          }
          else{
             if(hearAboutUs == 'Other' && $.trim($('#how-did-you-hear-about-us-other').val()) ==''){
               validated=false;
             }
            
          }
          if(validated==true){
          document.location.href = '/cart/checkout';
          }
        }

      });
      // $('.cart__submit[name="checkout"]').attr('disabled',false); 
      $('.cart__error-message-wrapper').addClass('hide');
      $('.cart__error-message').html(" ");
    }
    else{
      _this.attr('disabled',false);
      // $('.cart__submit[name="checkout"]').attr('disabled',true);
      $('.cart__error-message-wrapper').removeClass('hide');
      $('.cart__error-message').html("Fill all the passenger Details");
    }

  });

   $('body').on('change','.recive_vacci',function(e) {
      e.preventDefault();
     
     var vacVal = $('.kit_gov:checked').val();
//      if(vacVal =='yes'){
//          $('.addess_kit').addClass('medium-up--one-half');
//        $('.addess_kit').removeClass('full-up--one-half');
//      }else if(vacVal =='no'){
//    $('.addess_kit').removeClass('medium-up--one-half');
//        $('.addess_kit').addClass('full-up--one-half');
//      }
     
    if (this.value == 'yes') {
        $('.vacciname').show();
    }
    else if (this.value == 'no') {
      $('.vacciname').hide();
      $('.vacciName').val('');
        
    }
});
    $('body').on('change','.kit_gov',function(e) {
      e.preventDefault();
      var vacVal = $('.recive_vacci:checked').val();
      console.log(vacVal);
//       if(vacVal =='yes'){
//        //$('.addess_kit').removeClass('medium-up--one-half');
//       $('.addess_kit').addClass('medium-up--one-half');
//         //$('.kitadd').css('width','90px');
//       } else if(vacVal =='no'){
//       $('.addess_kit').removeClass('medium-up--one-half');
//       $('.addess_kit').addClass('full-up--one-half');
//         $('.kitadd').css('width','95%');
//       }
    if (this.value == 'yes') {
        $('.addess_kit').hide();
     $('.addressl1').val('');
      $('.addressl2').val('');
      $('.addressTown').val('');
      $('.addressPostalCode').val('');
    }
    else if (this.value == 'no') {
      $('.addess_kit').show();
        
    }
});
  $('body').on('change','.isolate',function(e) {
    e.preventDefault();
    if (this.value == 'yes') {
      $('.cst_hide').children('input').val('');
        $('.cst_hide').hide();
    }
    else if (this.value == 'no') {
      $('.cst_hide').show();
      
        
    }
});
  
  $("body .addDetails").datepicker({
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy',
    yearRange: '1900:2030', // specifying a hard coded year range
  });
  
// date picker 
   $( ".date" ).datepicker({ minDate: 0,dateFormat: 'dd/mm/yy'});

  
  // DOB
  $(".DOB").datepicker({
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy',
    yearRange: '1900:2030', // specifying a hard coded year range
  });
  
      $(".date_arrival").datepicker({
      dateFormat: 'dd/mm/yy',
    changeMonth: true,
    changeYear: true,
    yearRange: '1900:2030', // specifying a hard coded year range
  });
  
  $(".ldp").datepicker({
    dateFormat: 'dd/mm/yy',
    changeMonth: true,
    changeYear: true,
    yearRange: '1900:2030', // specifying a hard coded year range
  });
  
  $('body').on('click','.main-calendar img',function() {
    $(this).parents('.main-calendar').find('.date').focus();
     $(this).parents('.main-calendar').find('.DOB').focus();
      $(this).parents('.main-calendar').find('.addDetails').focus();
  });
  
$('body').on('click','.no-btn',function(e){
     e.preventDefault();
     var $this = $(this);
     $this.parent('p').remove();
  
  
  });
  /* click on yes button*/
  $('body').on('click','.yes_btn',function(e){
    e.preventDefault();
    var $this = $(this);
    var productqty=parseInt($(this).attr('data-productQTY'));
    var productId=$(this).attr('data-productId');
    var productTitle=$(this).attr('href');
    var nationality=$('#nationality1').html();
    var passengerNewData ='';    
    var j =parseInt($('.details:last').attr("data-index")) ;
    var UK_Product,flag,Uk_QTY,dateLength=0,LocationVal,LocationVal1,LocationVal2,i,k,lastDivIndex;
    if(productId =='6770670174413'){
      flag=1;
      Uk_QTY=productqty;
    }

    dateLength= $('.date').length;
    LocationVal=$('.passenger_detail_inner .Locator_number:last').val();
    if(LocationVal != undefined){
      LocationVal1=LocationVal.split('000')[0];
      LocationVal2=parseInt(LocationVal.split('000')[1]) + 1;
      LocationVal=LocationVal1+'000'+LocationVal2;
    }
    if($('.details[data-productId="'+productId+'"]:last').length > 0){
      lastDivIndex=$('.details[data-productId="'+productId+'"]:last').attr('data-index');
       productqty= productqty -(parseInt(lastDivIndex));
     }
      i= parseInt(j) +1;
      passengerNewData ='<div class="details detail-'+i+'" data-index="'+i+'" data-productId="'+productId+'" data-productQTY="'+i+'"><h4>passenger '+i+' DETAIL FOR  <strong>'+productTitle +'</strong></h4><div class="grid__item medium-up--one-half text-left"><label for="first_name'+i+'">First Name</label><input type="text" id="first_name'+i+'" name="First_Name'+i+'" value="" class="fName"></div><div class="grid__item medium-up--one-half text-left"><label for="last_name'+i+'">Last Name</label><input type="text" id="last_name'+i+'" name="Last_Name'+i+'" value="" class="lName"></div><input type="hidden" id="FullName'+i+'" name="attributes['+i+'- '+productTitle +'- Passenger]" value="" class="FullName">';
      if(flag == 1 && dateLength<Uk_QTY){
        UK_Product='<div class="grid__item medium-up--one-full text-left main-calendar"><label for="date'+i+'">What date do you depart the UK? (You will take your test with you on your trip.) </label><input style="width:96%" required="" type="text" id="date'+i+'" name="attributes['+i+'- '+productTitle +'- date]" value="" class="date"><img src="//cdn.shopify.com/s/files/1/0591/1855/1245/t/7/assets/calendar.png?v=13036757565515135103" alt="calendar.png"></div><div class="grid__item medium-up--one-half text-left main-calendar"><label for="dob'+i+'">Date of Birth </label><input required="" type="text" id="dob'+i+'" name="attributes['+i+'- '+productTitle +'- DOB]" value="" class="DOB"><img src="//cdn.shopify.com/s/files/1/0591/1855/1245/t/7/assets/calendar.png?v=13036757565515135103" alt="calendar.png"></div> <div class="grid__item medium-up--one-half text-left"><label for="pn'+i+'">Passport number? </label><input required="" type="text" id="pn'+i+'" name="attributes['+i+'- '+productTitle +'- Passport number]" value="" class="PassNo"></div>'
        passengerNewData+=UK_Product;
      }
      else{
        passengerNewData+='<input type="hidden" id="Locator_number'+i+'" name="attributes['+i+'- '+productTitle +'- Passenger Locator Number]" value="'+LocationVal+'" class="Locator_number">';
      }
      if(productId=='6701757694157' || productId=='6701431521485'){
        passengerNewData+='  <div class="grid__item medium-up--one-full text-left  main-calendar" >';
        passengerNewData+='    <label for="addDetails'+i+'">Additional Details </label>';
        passengerNewData+='    <input style="width:96%" required type="text" id="addDetails'+i+'" name="attributes['+i+'- '+productTitle +'- Additional Details]" value="" class="addDetails">';
        passengerNewData+='  <img src="//cdn.shopify.com/s/files/1/0591/1855/1245/t/9/assets/calendar.png?v=13036757565515135103" alt="Calendar"/>  </div>';
     	
      }
    
    if(productId =='6812726198477' || productId =='6701757071565' || productId =='6701417431245' || productId =='6793210101965'|| productId =='6858007052493'){
      passengerNewData +='<div class="grid__item medium-up--one-half text-left"><label for="email'+i+'">Email</label><input type="email" id="email'+i+'"  name="attributes['+i+'- '+productTitle +'- Email]" class="email" required /></div>';
      passengerNewData +='<div class="grid__item medium-up--one-half text-left"><label for="phone'+i+'">Phone</label><input type="text" id="phone'+i+'" name="attributes['+i+'- '+productTitle +'- Phone]" class="phone" /></div>';
      passengerNewData +='<div class="grid__item medium-up--one-half text-left main-calendar"><label for="dob'+i+'">Date of Birth </label><input required type="text" id="dob'+i+'" name="attributes['+i+'- '+productTitle +'- DOB]"  class="DOB"><img src="//cdn.shopify.com/s/files/1/0591/1855/1245/t/9/assets/calendar.png?v=13036757565515135103" alt="Calendar"/></div>';
      passengerNewData +='<div class="grid__item medium-up--one-half text-left"><label for="nhs'+i+'">NHS Number</label><input type="text" id="nhs'+i+'" name="attributes['+i+'- '+productTitle +'- NHS]" class="NhsNo"/></div>';
      passengerNewData +='<div class="grid__item medium-up--one-half text-left"><label for="pn'+i+'">Passport number? </label><input required type="text" id="pn'+i+'" name="attributes['+i+'- '+productTitle +'- PN]" class="PassNo"/></div>';
      passengerNewData +='<div class="grid__item medium-up--one-half text-left"><label for="phone'+i+'">Gender</label><div class="inline" style="display:inline;"><select class="sexval" name="attributes['+i+'- '+productTitle +'- sex]" id="sex_'+i+'" ><option value="male" selected="selected">Male</option><option value="female">Female</option><option value="other">Other</option></select></div></div>';
      passengerNewData +='<div class="grid__item medium-up--one-half text-left "><label for="nationality'+i+'">Nationality</label><select id="nationality'+i+'" class="nation cstnt" name="attributes['+i+'- '+productTitle +'- Nationality]" autocomplete="country">'+nationality+'</select></div>';
      passengerNewData +='<div class="grid__item medium-up--one-half text-left "><label for="ehnicity'+i+'">Ethnicity</label><select id="ehnicity'+i+'" name="attributes['+i+'- '+productTitle +'- Ehnicity]" autocomplete="country" class="ethicity"><option disabled selected>Please select an Ethnicity</option><option value="asian/asian-british">Asian/Asian British</option><option value="african">African</option><option value="black/african/caribbean/black-british">Black/African/caribbean/Black British</option><option value="chinese">Chinese</option><option value="mixed/multiple-ethnic-groups">Mixed/Multiple ethnic groups</option><option value="other-ethnic-groups">Other ethnic group</option><option value="irish-traveler">Irish Traveler</option><option value="not-provided">Not Provided</option><option value="arab">Arab</option><option value="white">White</option><option value="white-and-asian">White and Asian</option><option value="white/black-african">White and Black African</option><option value="white-british">White British</option><option value="white-other">White Other</option><option value="any-other-ethnic-category">Any Other Ethnic Category</option><option value="any-other-mixed-group">Any Other Mixed Group</option><option value="indian">Indian</option><option value="black-african">Black-African</option><option value="black-caribbean">Black-Caribbean</option><option value="black-other">Black-Other</option><option value="bangladeshi">Bangladeshi</option><option value="pakistani">Pakistani</option><option value="unknown">Unknown</option><option value="other/mixed">Other/Mixed</option><option value="black-african-american">Black African American</option></select></div>';
      passengerNewData +='<div class="grid__item medium-up--one-half text-left"><label>Have you received your vaccine ?</label><input type="radio" id="vacca'+i+'" name="attributes['+i+'- '+productTitle +'- vaccine]" value="yes" class="recive_vacci"/><label for="vacca'+i+'">Yes</label><input type="radio" id="vaccb'+i+'" name="attributes['+i+'- '+productTitle +'- vaccine]" checked  value="no" class="recive_vacci"/><label for="vaccb'+i+'">No</label></div>';
      passengerNewData +='<div class="grid__item medium-up--one-half text-left main-calendar vacciname" style="display:none;"><label for="vacc'+i+'">Vaccine Name</label><select id="vaccName'+i+'" name="attributes['+i+'- '+productTitle +'- vaccineName]" class="vacciName"><option disabled selected>Select Vaccine</option><option value="Pfizer">Pfizer</option> <option value="AstraZeneca">AstraZeneca</option><option value="Moderna">Moderna</option> <option value="Johnson&Johnson">Johnson & Johnson</option><option value="Other">Other</option></select></div>';
    
      passengerNewData +='<div class="grid__item medium-full--one-half text-left cst_text"><h2>Home address</h2></div><div class="grid__item medium-up--one-half text-left cst_hide"><label for="haddressl1'+i+'">Address Line 1</label><input type="text" id="haddressl1'+i+'" name="attributes['+i+'- '+productTitle +'- Home Address line 1]" class="homeaddressl1"/></div>';
      passengerNewData +=' <div class="grid__item medium-up--one-half text-left cst_hide"><label for="addressl2'+i+'">Address Line 2</label><input type="text" id="haddressl2'+i+'" name="attributes['+i+'- '+productTitle +'- Home Address line 2]"  class="homeaddressl2"/></div>';
      passengerNewData +='<div class="grid__item medium-up--one-half text-left cst_hide"><label for="haddressTown'+i+'">Town/City</label><input type="text" id="haddressTown'+i+'" name="attributes['+i+'- '+productTitle +'- Home Address Town]"  class="homeaddressTown"/></div>';
      passengerNewData +=' <div class="grid__item medium-up--one-half text-left cst_hide"><label for="haddressPostalCode'+i+'">Postal Code</label><input type="text" id="haddressPostalCode'+i+'" name="attributes['+i+'- '+productTitle +'- Home Address Postal Code]" class="homeaddressPostalCode"/></div>';


      
      passengerNewData +='<div class="grid__item medium-full--one-half text-left govt_text"><label>If you test positive the government will send you a confirmatory test. Will the address they send this to be the same as the above?</label><input type="radio" id="kita'+i+'" name="attributes['+i+'- '+productTitle +'- Goverment Kit]" value="yes" checked class="kit_gov"/><label for="kita'+i+'">Yes</label><input type="radio" id="kitb'+i+'" name="attributes['+i+'- '+productTitle +'- Goverment Kit]"   value="no" class="kit_gov"/><label for="kitb'+i+'">No</label></div>';
     // passengerNewData +=' <div class="grid__item  text-left addess_kit" style="display:none;"><label for="kitadd'+i+'">Alternate address</label><input type="text" id="kitadd'+i+'" name="attributes['+i+'- '+productTitle +'- Goverment Kit Address]"  class="kitadd"/></div>';
     //passengerNewData +=' <div class="grid__item medium-up--one-full text-left"><label>Are you self isolating at the address you will enter for billing on the following screen?</label><input type="radio" id="isoa'+i+'" checked name="attributes['+i+'- '+productTitle +'- ISO]" value="yes" class="isolate"/><label for="isoa'+i+'">Yes</label><input type="radio" id="isob'+i+'" name="attributes['+i+'- '+productTitle +'- ISO]" value="no" class="isolate"/><label for="isob'+i+'">No</label></div>';
      
      
      
      passengerNewData +='<div class="grid__item  text-left addess_kit" style="display:none;"> <div class="grid__item medium-full--one-half text-left cst_text"><h2>Alternate address </h2></div><div class="grid__item medium-up--one-half text-left cst_hide"><label for="addressl1'+i+'">Address Line 1</label><input type="text" id="addressl1'+i+'" name="attributes['+i+'- '+productTitle +'- Alternate Address line 1]" class="addressl1"/></div>';
      passengerNewData +=' <div class="grid__item medium-up--one-half text-left cst_hide"><label for="addressl2'+i+'">Address Line 2</label><input type="text" id="addressl2'+i+'" name="attributes['+i+'- '+productTitle +'- Alternate Address line 2]"  class="addressl2"/></div>';
      passengerNewData +='<div class="grid__item medium-up--one-half text-left cst_hide"><label for="addressTown'+i+'">Town/City</label><input type="text" id="addressTown'+i+'" name="attributes['+i+'- '+productTitle +'- Alternate Address Town]"  class="addressTown"/></div>';
      passengerNewData +=' <div class="grid__item medium-up--one-half text-left cst_hide"><label for="addressPostalCode'+i+'">Postal Code</label><input type="text" id="addressPostalCode'+i+'" name="attributes['+i+'- '+productTitle +'- Alternate Address Postal Code]" class="addressPostalCode"/></div></div>';

      
       passengerNewData +=' <div class="grid__item medium-full--one-half text-left cst_text"><h2>Travel  Details </h2></div>';
      passengerNewData +='<div class="grid__item medium-up--one-half text-left " style="clear:both;"><label for="dept_country'+i+'">Country of Departure</label><select class="dep_country" id="dept_country'+i+'" name="attributes['+i+'- '+productTitle +'- Deptcountry]" autocomplete="country">'+nationality+'</select></div>';
      passengerNewData +='<div class="grid__item medium-up--one-half text-left "><label for="travelNo'+i+'">Travel Number (Flight/Coach/Vessel Number)</label><input type="text" id="travelNo'+i+'" name="attributes['+i+'- '+productTitle +'- TravelNumber]" class="travel_no"/></div>';
      passengerNewData +='<div class="grid__item medium-up--one-half text-left main-calendar"><label for="arrival'+i+'">Date of Arrival</label><input type="text" id="arrival'+i+'" name="attributes['+i+'- '+productTitle +'- dateArrival]" class="date_arrival"/> <img src="//cdn.shopify.com/s/files/1/0591/1855/1245/t/9/assets/calendar.png?v=13036757565515135103" alt="Calendar"/></div>';
      passengerNewData +=' <div class="grid__item medium-up--one-half text-left main-calendar"><label for="arrtime'+i+'">Time of Arrival</label><input type="time" id="arrtime'+i+'" name="attributes['+i+'- '+productTitle +'- timeArrival]" min="09:00" max="18:00" class="time_arrivals" style="width:90%;" /></div>';
      
//       passengerNewData +='<div class="grid__item medium-up--one-half text-left "><label for="travel_level'+i+'">Please select a Travel Country Level</label><select id="travel_level'+i+'" name="attributes['+i+'- '+productTitle +'- travelLevel]}}]" class="cntry_level"><option disabled selected>Travel country level</option><option value="red">Red</option><option value="non-red">Non red</option></select></div>';
//       passengerNewData +='<div class="grid__item medium-up--one-half text-left"><label for="nhs'+i+'">NHS Number</label><input type="text" id="nhs'+i+'" name="attributes['+i+'- '+productTitle +'- NHS]" class="NhsNo"/></div>';
      passengerNewData +=' <div class="grid__item medium-up--one-full text-left"><label for="territoryC'+i+'">Country or territory you were travelling from when you arrived in the UK, and any country or territory they transited through as part of that journey?</label><input type="text" id="territoryC'+i+'" name="attributes['+i+'- '+productTitle +'- ttCountry]" class="ttCountry" style="width:96%"/></div>';
       passengerNewData +='<div class="grid__item medium-up--one-full text-left main-calendar"><label for="ldp'+i+'">Date on which you last departed from or transited through a country or territory outside the common travel area?</label><input type="text" id="ldp'+i+'" name="attributes['+i+'- '+productTitle +'- LDP]" class="ldp" style="width:96%"/><img src="//cdn.shopify.com/s/files/1/0591/1855/1245/t/9/assets/calendar.png?v=13036757565515135103" alt="Calendar"/> </div>';

    }
      passengerNewData+='</div>';
      var wrapper = $('.passenger_detail_inner');
      if($('.details[data-productId="'+productId+'"]:last').length > 0){
        $(passengerNewData).insertAfter($('.details[data-productId="'+productId+'"]:last'));
      }else{
         $(passengerNewData).insertAfter($('.details:last'));
      }
    $(".addDetails").datepicker({
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy',
      yearRange: '1950:2022', // specifying a hard coded year range
    });

    $("body .date").datepicker({ minDate: 0}); // reinitiallized the date 
    //  reinitiallized the DOB 
    $(".DOB").datepicker({
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy',
      yearRange: '1950:2022', // specifying a hard coded year range
    });
    $(".date_arrival").datepicker({
      dateFormat: 'dd/mm/yy',
      changeMonth: true,
      changeYear: true,
      yearRange: '1950:2022', // specifying a hard coded year range
    });
  
    $(".ldp").datepicker({
      dateFormat: 'dd/mm/yy',
      changeMonth: true,
      changeYear: true,
      yearRange: '1950:2022', // specifying a hard coded year range
    });
          
//     for(k=1;k<=productqty;k++){
//       i= parseInt(j)+k;
//       passengerNewData ='<div class="details detail-'+i+'" data-index="'+i+'" data-productId="'+productId+'" data-productQTY="'+i+'"><h4>passenger '+i+' DETAIL FOR  <strong>'+productTitle +'</strong></h4><div class="grid__item medium-up--one-half text-left"><label for="first_name'+i+'">First Name</label><input type="text" id="first_name'+i+'" name="First_Name'+i+'" value="" class="fName"></div><div class="grid__item medium-up--one-half text-left"><label for="last_name'+i+'">Last Name</label><input type="text" id="last_name'+i+'" name="Last_Name'+i+'" value="" class="lName"></div><input type="hidden" id="FullName'+i+'" name="attributes['+i+'- '+productTitle +' Passenger]" value="" class="FullName">';
//       if(flag == 1 && dateLength<Uk_QTY){
//         UK_Product='<div class="grid__item medium-up--one-full text-left main-calendar"><label for="date'+i+'">What date do you depart the UK? (You will take your test with you on your trip.) </label><input style="width:96%" required="" type="text" id="date'+i+'" name="attributes['+i+'- '+productTitle +'- date]" value="" class="date"><img src="//cdn.shopify.com/s/files/1/0591/1855/1245/t/7/assets/calendar.png?v=13036757565515135103" alt="calendar.png"></div><div class="grid__item medium-up--one-half text-left main-calendar"><label for="dob'+i+'">Date of Birth </label><input required="" type="text" id="dob'+i+'" name="attributes['+i+'- '+productTitle +'- DOB]" value="" class="DOB"><img src="//cdn.shopify.com/s/files/1/0591/1855/1245/t/7/assets/calendar.png?v=13036757565515135103" alt="calendar.png"></div> <div class="grid__item medium-up--one-half text-left"><label for="pn'+i+'">Passport number? </label><input required="" type="text" id="pn'+i+'" name="attributes['+i+'- '+productTitle +'- Passport number]" value="" class="PassNo"></div>'
//         passengerNewData+=UK_Product;
//       }
//       else{
//         passengerNewData+='<input type="hidden" id="Locator_number'+i+'" name="attributes['+i+'- '+productTitle +'- Passenger Locator Number]" value="'+LocationVal+'" class="Locator_number">';
//       }
//       if(productId=='6701757694157' || productId=='6701431521485'){
//         passengerNewData+='  <div class="grid__item medium-up--one-full text-left  main-calendar" >';
//         passengerNewData+='    <label for="addDetails'+i+'">Additional Details </label>';
//         passengerNewData+='    <input style="width:96%" required type="text" id="addDetails'+i+'" name="attributes['+i+'- '+productTitle +'- Additional Details]" value="" class="addDetails hasDatepicker">';
//         passengerNewData+='  <img src="//cdn.shopify.com/s/files/1/0591/1855/1245/t/9/assets/calendar.png?v=13036757565515135103" alt="Calendar"/>  </div>';
//       }
//       passengerNewData+='</div>';
//       var wrapper = $('.passenger_detail_inner');
//       if($('.details[data-productId="'+productId+'"]:last').length > 0){
//         $(passengerNewData).insertAfter($('.details[data-productId="'+productId+'"]:last'));
//       }else{
//          $(passengerNewData).insertAfter($('.details:last'));
//       }
//     }  
        
     $this.parent('p').remove();
  
  });
  
});